import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const id = () => {
    let s4 = () => {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    return s4()+s4();
}


const useTaskStore = create(
    persist( 
        (set) => ({
            bears: 0,
            tasks: [{ id: id(), status: 'open', name: 'New: Start here...', badge: 'New' }],
            badges: [],

            addTask: ( newTaskName )  => set( (state) => {
                const split = newTaskName.split(":")
                const badge = split.length > 0 ? split[0] : '';

                let badges = [...state.badges];
                if(!badges.includes(badge) && split.length > 1) {
                    badges.push(badge);
                }

                return { 
                    tasks : [...state.tasks, { id: id(), name: newTaskName, status: 'open', badge: badge }],
                    badges : badges
                 }
            }),

            toggleTaskStatus: ( id ) => {
            
                set( (state) => {
            
                    const taskIndex = state.tasks.findIndex( task => task.id === id)
                    const task = state.tasks[taskIndex]
            
                    task.status = task?.status === 'open' ? 'closed' : 'open';
            
                    return { tasks: [...state.tasks.slice(0, taskIndex), task, ...state.tasks.slice(1 + taskIndex) ] }
                })
            },

            removeTask: ( id ) => {
                // TODO: Clear out the badge associated with it if unique
                set( (state) => {
                    return { tasks: state.tasks.filter((_t) => _t.id !== id ),
                    };
                });
            },
            sortTasks: () => { set( (state) => { return { tasks: state.tasks.sort( (a,b) => a.name.localeCompare(b.name)) } })},
            clearCompletedTasks: () => {
                set( (state) => {
                    const cleanedList = [];
            
                    state.tasks.map(item => {
                        if(item.status !== 'open') return false;
            
                        cleanedList.push(item);
                        return true;
                    });
            
                    return { tasks: cleanedList }
                })
            },

            increasePopulation: () => set((state) => ({ bears: state.bears + 1 })),
            removeAllTasks: () => set({ tasks: [] }),
            removeAllBadges: () => set({ badges: [] }),

            getBadgeIndex: ( badge ) => set( state => {
                let index = state.badges.findIndex( item => item === badge );
                return index
            }),

            createBadgesFromStorage: (storedState)  => {
                let tasks = storedState.tasks;
                let badgesArray = [...storedState.badges];


                tasks.map( task => {
                    const name = task.name;
                    const split = name.split(":")
                    const badge = split.length > 0 ? split[0] : '';

                    //console.log(task, name, split, badge, badgesArray);
    
                    if(!badgesArray.includes(badge) && split.length > 1) {
                        badgesArray.push(badge);
                    }
                    return badge;
                })

                return badgesArray
            }
    }), 
    { 
        name: 'd-store',
        partialize: (state) => ({ tasks: state.tasks }),
        onRehydrateStorage: (state) => {
            console.log('Hydration Initiated')

            return(state, error) => {
                const { createBadgesFromStorage } = state;
                const badgeList =  createBadgesFromStorage(state);

                if(error) {
                    console.log('an error happened during hydration', error)
                } else {
                    //console.log('hydration finished ', badgeList)
                    state.badges = badgeList
                    return { badges: badgeList }
                }
            }
        }
    }))

export { useTaskStore }